module.exports = __webpack_public_path__ + "static/media/icon-variedade-imoveis.38b6f442.svg";